import React, { useEffect, useRef, useState } from 'react';
import { Menu } from '../_Menu';
import Pagger from '../components/_Pagger';
import Header from '../Header';
import { Select } from 'antd';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faWrench } from '@fortawesome/free-solid-svg-icons';
import { TreatmentFilterModel, TreatmentModel } from '../models/superbit-api-models';
import { CustomerCardModel } from '../models/CustomerCardModel';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import ClientTreatmentAssignment from '../clients/_ClientTreatmentAssignment';
import TasksTable from './_TasksTable';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import LoginPopup from '../login/_LoginPopUp';
import TasksAddTaskPopup from './_TasksAddTaskPopup';
// import ClientTreatmentTabConfigPopup from '../clients/_ClientTreatmentTabConfigPopup';
import TasksSendEmailPopup from './_TasksSendEmailPopup';
import TasksSendWhatsAppPopup from './_TasksSendWhatsAppPopup';
import { SimulatorModel } from '../models/SimulatorModel';
import ConfirmPopUp from './_ConfirmPopup';
import ClientTreatmentConfigPopup from '../clients/_ClientTreatmentConfigPopup';
import { LeadMessagePopup } from '../leads/_LeadMessagePopup';
import { LeadDocumentPopup } from '../leads/_LeadDocumentPopup';
import { stat } from 'fs';
import { assign, filter, get, set, update } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import { WhatsAppModel } from '../models/WhatsAppModel';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { setAllRowsCounter, setPopUpTreatmentModel, setTreatmentId, setTreatmentListStore, setTypeTreatmentsAction } from '../app-context/tasksSlice';
import ClientAddTreatmentPopup from '../clients/_ClientAddTreatmentPopup';
import { RootState } from '../app-context/store';
import { setLeadIdForTreatment } from '../app-context/leadsSlice';
import { TaskDocumentPopup } from './_TaskDocumentPopup';
import SignalTaskServiceModel from '../models/SignalTaskServiceModel';
import _ from 'lodash';
import { log } from 'console';

const newCreatorsList: any = [
    {
        label: 'יוזרים פעילים',
        value: '0'
    },
    {
        label: 'יוזרים לא פעילים',
        value: '1'
    },
    {
        label: 'כל היוזרים',
        value: '2'
    }
]

const hList = [{
    label: 'יוזרים פעילים',
    value: '0'
},
{
    label: 'יוזרים לא פעילים',
    value: '1'
},
{
    label: 'כל היוזרים',
    value: '2'
},]


const Tasks = () => {
    const customerCardModel: CustomerCardModel = new CustomerCardModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const whatsAppModel: WhatsAppModel = new WhatsAppModel();

    const didInitRef = useRef(false);

    const [loading, setLoading] = useState<boolean>(false);
    const userLogged = useSelector((state: any) => state.user.value)
    const [currentUser, setCurrentUser] = useState<any | null>();

    const [selectedAssigment, setSelectedAssigment] = useState<any>(null)
    const [creatorsOptionsOld, setCreatorsOptionsOld] = useState<any[]>([]);
    // const [handleOption, setHandleOption] = useState<any[]>([...hList]);

    const [typeCreatorsList, setTypeCreatorsList] = useState<any[]>([]);
    const [creatorsList, setCreatorsList] = useState<any[]>([]);

    const [typeHandlersOptions, setTypeHandlersOptions] = useState<any[]>([]);
    const [handlersOptions, setHandlersOptions] = useState<any[]>([]);

    const [treatmentsList, setTreatmentsList] = useState<any[] | null>([]);
    const [treatmentsFilter, setTreatmentsFilter] = useState<any>({
        page: 1
    });
    const [sortBy, setSortBy] = useState<any | undefined>({
        property: "endDate",
        SortDirection: "ASC"
    });
    const [treatmentsSeachText, setTreatmentsSearchText] = useState<string>('');
    // const [treatmentCreatedBy, setTreatmentCreatedBy] = useState<string>('1');
    const [treatmentSeachType, setTreatmentSeachType] = useState<string>('-1');
    const [treatmentSeachStatus, setTreatmentSeachStatus] = useState<string>('-1');

    const [treatmentSearchTypeCreatedBy, setTreatmenSearchTypeCreatedBy] = useState<string>('');
    const [treatmentSearchCreatedBy, setTreatmenSearchCreatedBy] = useState<string>('');

    const [treatmentSearchTypeHandledBy, setTreatmenSearchTypeHandledBy] = useState<string>('');
    const [treatmentSearchHandledBy, setTreatmenSearchHandledBy] = useState<string>('');

    const [treatmentsTimeoutId, setTreatmentsTimeoutId] = useState<number | any | null>(undefined);
    const [treatmentsStartDate, setTreatmentsStartDate] = useState<Date | null>(null)
    const [treatmentsEndDate, setTreatmentsEndDate] = useState<Date | null>(null)

    const [showAddTreatmentPopUp, setShowAddTreatmentPopup] = useState<boolean>(false);
    const [showSendEmailPopUp, setShowSendEmailPopup] = useState<boolean>(false);
    const [showSendWhatsAppPopUp, setShowSendWhatsAppPopup] = useState<boolean>(false);
    const [showTreatmentConfigPopUp, setShowTreatmentConfigPopup] = useState<boolean>(false);
    const [showDeleteAssignmentPopUp, setShowDeleteAssignmentPopup] = useState<boolean>(false);

    const [assigmentStatuses, setAssignmentStatuses] = useState<any[]>([]);
    const [insuranceCompanyList, setInsuranceCompanyList] = useState<any[]>([]);
    const [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState<string>('');

    const [agentsList, setAgentsList] = useState<any[]>([]);
    const [agents, setAgents] = useState<any[]>([])
    const [selectedAgent, setSelectedAgent] = useState<string>('0');
    const [selectedDateParam, setSelectedDateParam] = useState<string>('0')

    const [assignmentIdForDelete, setAssignmentIdForDelete] = useState<string | null>(null)

    // const [currentPage, setCurrentPage] = useState<number>(1)

    const [pagerConf, setPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });

    const [popupMessageContent, setPopupMessageContent] = useState<string | null>(null)
    const [popupMessageTitle, setPopupMessageTitle] = useState<string | undefined>(undefined);

    const [documentUrl, setDocumentUrl] = useState<any[]>([]);
    // const [customersList, setCustomersList] = useState<any[]>([]);
    const [usersList, setUsersList] = useState<any[]>([]);

    const [treatmentsTypeList, setTreatmentsTypeList] = useState<any[]>([]);

    // const [treatmentId, setTreatmentId] = useState<string>('');

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const location = useLocation();

    const popUpTreatmentModel = useSelector((state: RootState) => state.tasks.popUpTreatmentModel);
    const treatmentListStore = useSelector((state: RootState) => state.tasks.treatmentListStore);
    const allRowsCounter = useSelector((state: RootState) => state.tasks.allRowsCounter);


    const loadFilterFromLocalStorage = async () => {
        console.log('loadFilterFromLocalStorage');
        const lastTasksFilter = localStorage.getItem('lastTasksFilter');
        if (lastTasksFilter && lastTasksFilter !== '{}') {
            console.log('loadFilterFromLocalStorage - found lastTasksFilter');

            const filterStorage = JSON.parse(lastTasksFilter);
            const newFilter: any = treatmentsFilter;
            // console.log('creatorsList', creatorsList)
            // console.log('filterStorage', filterStorage)
            // console.log('creatorsOptionsOld', creatorsOptionsOld)


            if (filterStorage.assignmentStatus) {
                newFilter.assignmentStatus = filterStorage.assignmentStatus;
                setTreatmentSeachStatus(filterStorage.assignmentStatus);
            }

            if (filterStorage.createdBy || filterStorage.createdBy == "0") {
                newFilter.createdBy = filterStorage.createdBy;
                let creatorNameBy = newCreatorsList.find((a: any) => a.value == filterStorage.createdBy);
                if (creatorNameBy) {
                    setTreatmenSearchTypeCreatedBy(creatorNameBy.label)
                }
            }

            if (filterStorage.creatorsList) {
                newFilter.creatorsList = filterStorage.creatorsList;
                setCreatorsList(filterStorage.creatorsList)
            }

            if (filterStorage.createdById && filterStorage.creatorsList && filterStorage.creatorsList.length > 0) {
                newFilter.createdById = filterStorage.createdById;
                let creatorNameById = filterStorage.creatorsList.find((a: any) => a.value == filterStorage.createdById);
                if (creatorNameById) {
                    setTreatmenSearchCreatedBy(creatorNameById.label)
                }
            }


            if (filterStorage.treatmentBy || filterStorage.treatmentBy == "0") {
                newFilter.treatmentBy = filterStorage.treatmentBy;
                const hendler = hList.find((a: any) => a.value == filterStorage.treatmentBy);
                if (hendler) {
                    setTreatmenSearchTypeHandledBy(hendler.label)
                }
            }

            if (filterStorage.handlersOptions) {
                newFilter.handlersOptions = filterStorage.handlersOptions;
                setHandlersOptions(filterStorage.handlersOptions)
            }

            if (filterStorage.treatmentById && filterStorage.handlersOptions && filterStorage.handlersOptions.length > 0) {
                newFilter.treatmentById = filterStorage.treatmentById;
                let handlerNameById = filterStorage.handlersOptions.find((a: any) => a.value == filterStorage.treatmentById);
                if (handlerNameById) {
                    setTreatmenSearchHandledBy(handlerNameById.label)
                }
            }
            if (filterStorage.treatmentType || filterStorage.treatmentType == "0") {
                newFilter.treatmentType = filterStorage.treatmentType;
                setTreatmentSeachType(filterStorage.treatmentType)
            }

            if (filterStorage.insuranceCompanyId) {
                const insuranceCompaniesStorage = localStorage.getItem('insuranceCompanies');
                let insuranceCompaniesList: any[] = [];
                if (insuranceCompaniesStorage) {
                    insuranceCompaniesList = JSON.parse(insuranceCompaniesStorage);
                    newFilter.insuranceCompanyId = filterStorage.insuranceCompanyId;
                    const ic = insuranceCompaniesList.find((a: any) => a.value == filterStorage.insuranceCompanyId);
                    if (ic) {
                        setSelectedInsuranceCompany(ic.label)
                    }
                }
            }

            var agentsData: any[] = [];
            let agentsDataStorage = localStorage.getItem('agents');
            if (agentsDataStorage) {
                agentsData = JSON.parse(agentsDataStorage);
                if (filterStorage.agentId) {
                    newFilter.agentId = filterStorage.agentId;
                    const agent = agentsData.find((a: any) => a.id == filterStorage.agentId);
                    if (agent) {
                        setSelectedAgent(agent.name)
                    }
                }
            }

            if (filterStorage.selectedDateParam) {
                newFilter.selectedDateParam = filterStorage.selectedDateParam;
                setSelectedDateParam(filterStorage.selectedDateParam)
            }

            if (filterStorage.eventDateFrom) {
                newFilter.eventDateFrom = filterStorage.eventDateFrom;
                setTreatmentsStartDate(filterStorage.eventDateFrom);
            }
            if (filterStorage.eventDateTo) {
                newFilter.eventDateTo = filterStorage.eventDateTo;
                setTreatmentsEndDate(filterStorage.eventDateTo);
            }
            if (filterStorage.alertDateFrom) {
                newFilter.alertDateFrom = filterStorage.alertDateFrom;
                setTreatmentsStartDate(filterStorage.alertDateFrom);
            }
            if (filterStorage.alertDateTo) {
                newFilter.alertDateTo = filterStorage.alertDateTo;
                setTreatmentsEndDate(filterStorage.alertDateTo);
            }
            if (filterStorage.createdDateFrom) {
                newFilter.createdDateFrom = filterStorage.createdDateFrom;
                setTreatmentsStartDate(filterStorage.createdDateFrom);
            }
            if (filterStorage.createdDateTo) {
                newFilter.createdDateTo = filterStorage.createdDateTo;
                setTreatmentsEndDate(filterStorage.createdDateTo);
            }
            if (filterStorage.endDateFrom) {
                newFilter.endDateFrom = filterStorage.endDateFrom;
                setTreatmentsStartDate(filterStorage.endDateFrom);
            }
            if (filterStorage.endDateTo) {
                newFilter.endDateTo = filterStorage.endDateTo;
                setTreatmentsEndDate(filterStorage.endDateTo);
            }
            if (filterStorage.searchTerm) {
                newFilter.searchTerm = filterStorage.searchTerm;
                setTreatmentsSearchText(filterStorage.searchTerm);
            }

            const newConf = {...pagerConf};
            if (filterStorage.page) {
                newFilter.page = filterStorage.page;
                newConf.currentPage = filterStorage.page;
                // setCurrentPage(filterStorage.page);
            }

            await setTreatmentsFilter(newFilter);
            console.log('loadFilterFromLocalStorage-treatmentListStore', treatmentListStore)
            if (treatmentListStore && treatmentListStore.length > 0) {
                console.log("treatmentListStore", treatmentListStore)
                setTreatmentsList(treatmentListStore);
                setAllRowsCounter(allRowsCounter);
                const newConf = pagerConf;
                newConf.currentPage = filterStorage.page;
                newConf.totalItems = allRowsCounter
                setPagerConf(newConf)
            } else if (filterStorage != JSON.stringify({ "page": 1 })) {
                await getTreatments(newFilter);
            }

        } else {
            console.log('loadFilterFromLocalStorage - no lastTasksFilter found');

            const creatorsListStorage = localStorage.getItem('creatorsList');
            if (creatorsListStorage && creatorsListStorage !== '{}') {

                const loggedUser = localStorage.getItem('loggedUser');
                if (loggedUser && creatorsList) {
                    const dataList = buildOptionsForSelect(JSON.parse(creatorsListStorage), 'id', 'כל היוצרים');

                    const user = JSON.parse(loggedUser);

                    setTreatmenSearchHandledBy(user.name)

                    const newFilter: any = treatmentsFilter;
                    newFilter.createdById = undefined;

                    // console.log('creatorName', user.name)
                    const selected = dataList.find((a: any) => a.label == user.name);

                    if (selected) {
                        //newFilter.treatmentBy = '3';
                        // newFilter.treatmentById = selected.value;
                        setTreatmentsFilter(newFilter);

                        const tasksFilter = {
                            page: 1,

                            treatmentBy: '0',
                            createdBy: '0',
                            createdById: undefined,
                            treatmentById: selected.value,
                            assignmentStatus: '45cb3c16-f64f-40d5-9863-42a742ce4624',
                        } as any;
                        setTreatmentSeachStatus('45cb3c16-f64f-40d5-9863-42a742ce4624');
                        setTreatmenSearchTypeCreatedBy('יוזרים פעילים');

                        let newList = dataList.filter((c: any) => c.status == '0')
                        let sortedList = newList.sort((a: any, b: any) => a.label.localeCompare(b.label))
                        setCreatorsList(sortedList)
                        setHandlersOptions(sortedList)

                        tasksFilter["creatorsList"] = [...sortedList]
                        tasksFilter["handlersOptions"] = [...sortedList]

                        setTreatmenSearchTypeHandledBy('יוזרים פעילים');

                        setTreatmentsFilter(tasksFilter);

                        localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter))
                        getTreatments(tasksFilter);
                    }
                }
            }

        }
    }

    const init = async () => {
        await getComboData();
        // setTimeout(() => {

        // }, 1000);
        loadFilterFromLocalStorage();
    }

    const getComboData = async () => {
        setLoading(true);

        let assigmentStatusesData: any[] = [];
        const assignmentStatusesStorage = localStorage.getItem('AssignmentStatuses');
        if (assignmentStatusesStorage) {
            assigmentStatusesData = JSON.parse(assignmentStatusesStorage);
        } else {
            assigmentStatusesData = await customerCardModel.getAssignmentStatuses();
            localStorage.setItem('AssignmentStatuses', JSON.stringify(assigmentStatusesData));
        }

        setAssignmentStatuses(assigmentStatusesData.map((s: any) => {
            return {
                label: s.name,
                value: s.id
            }
        }))


        const treatmentTypesData = await customerCardModel.getTrearmentTypes();
        console.log('treatmentTypesData', treatmentTypesData)

        const fixedTreatmentTypes: any[] = [];
        const treatmentTypesKeys = Object.keys(treatmentTypesData);
        treatmentTypesKeys.forEach((k: string) => {
            fixedTreatmentTypes.push({
                value: treatmentTypesData[k].id,
                label: treatmentTypesData[k].description
            })
        })
        fixedTreatmentTypes.unshift({
            value: '-1',
            label: 'כל סוגי המשימות'
        })
        setTreatmentsTypeList(fixedTreatmentTypes);

        let usersListData: any[] = [];
        const creatorsListLocalStorage = localStorage.getItem('creatorsList');
        if (creatorsListLocalStorage) {
            usersListData = JSON.parse(creatorsListLocalStorage);
        } else {
            usersListData = await whatsAppModel.customerCardGetUsers();
        }
        const usersListActives = usersListData.filter((u: any, i: number) => u.status == 0
            /*&& (u.roleId == "4a0a7e1b-7e16-4134-b8b7-de6ef7ad2aec" || u.roleId == "e026af6f-52f0-40b6-b12f-94c546da1725"
                || u.branchId == "f65ba4e2-8fae-49da-b351-e288a9459f21" || u.branchId == "3b729183-d7a4-49a6-911e-35b63eb0c438")*/);
        setUsersList(usersListActives.map((u: any, i: number) => {
            return {
                value: u.id,
                label: u.fullName
            }
        }))

        const insuranceCompaniesStorage = localStorage.getItem('insuranceCompanies');
        let insuranceCompaniesList: any[] = [];
        if (insuranceCompaniesStorage) {
            insuranceCompaniesList = JSON.parse(insuranceCompaniesStorage);
            setInsuranceCompanyList(insuranceCompaniesList);

        } else {
            const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
            const icTempDataKeys = Object.keys(insuranceCompaniesData);
            const fixedInsuranceCompanies: any[] = [];
            icTempDataKeys.forEach((k: string) => {
                fixedInsuranceCompanies.push({
                    value: insuranceCompaniesData[k].description,
                    label: insuranceCompaniesData[k].name
                })
            })
            setInsuranceCompanyList(fixedInsuranceCompanies);
            localStorage.setItem('insuranceCompanies', JSON.stringify(fixedInsuranceCompanies));
        }


        if (creatorsListLocalStorage) {
            const dataList = buildOptionsForSelect(JSON.parse(creatorsListLocalStorage), 'id', 'כל היוצרים');
            console.log('dataList 454', dataList)
            setCreatorsOptionsOld(dataList)
            // const source = JSON.parse(creatorsList);
            const newCreatorsList: any = [
                {
                    label: 'יוזרים פעילים',
                    value: '0'
                },
                {
                    label: 'יוזרים לא פעילים',
                    value: '1'
                },
                {
                    label: 'כל היוזרים',
                    value: '2'
                }
            ]
            setTypeCreatorsList(newCreatorsList)
            // setCreatorsList(dataList)
        }

        // getHandlersList from local storage
        const handlersList = localStorage.getItem('handlersList');
        if (handlersList) {
            const hList = [{
                label: 'יוזרים פעילים',
                value: '0'
            },
            {
                label: 'יוזרים לא פעילים',
                value: '1'
            },
            {
                label: 'כל היוזרים',
                value: '2'
            },]
            setTypeHandlersOptions(hList)
            // setHandleOption(buildOptionsForSelect(JSON.parse(handlersList), 'id', 'כל מטפלים'))
        }



        var agentsData: any[] = [];
        let agentsDataStorage = localStorage.getItem('agents');
        if (agentsDataStorage) {
            agentsData = JSON.parse(agentsDataStorage);
        } else {
            agentsData = await simulatorModel.getCustomerCardAgents();
            localStorage.setItem('agents', JSON.stringify(agentsData));
        }

        setAgents(agentsData);
        setAgentsList(agentsData.map((a: any) => {
            return {
                value: a.id,
                label: a.name
            }
        }))


        setLoading(false);
    }

    const buildOptionsForSelect = (source: any[], param: string = 'id', label: string = 'הכל') => {
        const items: any[] = [];
        source.forEach((i: any) => {
            items.push(
                {
                    label: i.fullName,
                    value: i[param],
                    status: i.status
                }
            );
        })
        //console.log('buildOptionsForSelect', items);
        return items;
    }

    const onPageChange = (page: number) => {
        // if (page === 0) {
        //     page = 1;
        // }
        const newConf = {...pagerConf};
        let new_filter = {...treatmentsFilter};
        newConf.currentPage = page;
        new_filter.page = page;
        // setCurrentPage(page);
        setTreatmentsFilter(new_filter);
        setPagerConf(newConf);
        console.log('onPageChange', page);
        // const newFilter = treatmentsFilter;
        // newFilter.page = page;
        // setTreatmentsFilter(newFilter);
        // getTreatments(newFilter);
        // setTreatmentsFilter((prev: any) => ({ 
        //     ...prev,
        //     page,
        // }));
        getTreatments(new_filter); // check in future if need to change to newFilter
    }

    // treatments function
    const getTreatments = async (filter?: any) => {
        setLoading(true);
        setTreatmentsList(null);
        if (!filter) {
            filter = treatmentsFilter;
        }
        if (sortBy && !filter.sortBy) {
            filter.sortBy = [sortBy];
        }
        delete filter['creatorsList'];
        delete filter['handlersOptions']

        // assignmentsFilter
        // const treatmentsData = await customerCardModel.treatmentsFilter(filter);
        console.log('getTreatments-treatmentsFilter', filter);

        const treatmentsData = await customerCardModel.assignmentsFilter(filter);
        const treatments: TreatmentModel[] = [];
        if (treatmentsData) {
            if (treatmentsData.treatments && treatmentsData.treatments.length > 0) {
                treatmentsData.treatments.forEach((item: any) => {
                    const agentId = item.agentId;
                    if (agentId) {
                        const agent = agents.find((a: any) => a.id === agentId);
                        if (agent) {
                            item.agent = agent;
                        }
                    }
                    if (item.treatmentActivities && item.treatmentActivities.length > 0) {
                        const lastActivity = item.treatmentActivities[item.treatmentActivities.length - 1];
                        if (lastActivity && lastActivity.createdById !== '') {
                            item.updatedBy = lastActivity.createdBy;
                            item.updatedById = lastActivity.createdById;
                        }
                    }
                    treatments.push(item);
                })
            }

            setTreatmentsList(treatments);
            dispatch(setTreatmentListStore(treatments));
            dispatch(setAllRowsCounter(treatmentsData.allRowsCounter));
            const newConf = pagerConf;
            newConf.currentPage = filter.page;
            newConf.totalItems = treatmentsData.allRowsCounter
            // setCurrentPage(newConf.currentPage);
            setPagerConf(newConf)
        }
        setLoading(false);
    }

    const handleTreatmentSearchChange = async (event: any) => {
        const newSearchText = event.target.value;
        setTreatmentsSearchText(newSearchText);
        const newFilter = treatmentsFilter;
        newFilter.searchTerm = newSearchText;
        setTreatmentsFilter(newFilter);

        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter.searchTerm = newSearchText;
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }

        clearTimeout(treatmentsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            getTreatments(newFilter);
        }, 1000);
        setTreatmentsTimeoutId(newTimeoutId);
    };

    const setFilterTreatmentType = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        const newFilter = treatmentsFilter;


        if (parseInt(value) >= 0) {
            newFilter.treatmentType = parseInt(value);
        } else {
            newFilter.treatmentType = undefined
        }
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter.treatmentType = parseInt(value) >= 0 ? parseInt(value) : undefined;
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }
        console.log('value', value)
        console.log('newFilter', newFilter)
        setTreatmentSeachType(value)
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);

    }

    // const setFilterTreatmentType = (name: string, value: string) => {
    //     const newFilter = treatmentsFilter;
    //     if (value !== '0') {
    //         newFilter.treatmentType = parseInt(value);
    //     } else {
    //         newFilter.treatmentType = undefined
    //     }
    //     setTreatmentSeachType(value)
    //     setTreatmentsFilter(newFilter);
    //     getTreatments(newFilter);

    // }

    const setFilterTreatmentStatus = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        const newFilter = treatmentsFilter;
        newFilter.backlog = undefined;
        if (value !== '0' && value !== '-1') {
            newFilter.assignmentStatus = value;
        } else {
            newFilter.assignmentStatus = undefined
            // switch (value) {
            //     case '-2':
            //         newFilter.backlog = true;
            //         break;

            //     default:

            //         break;
            // }
        }
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter.assignmentStatus = value !== '0' && value !== '-1' ? value : undefined;
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }
        setTreatmentSeachStatus(value);
        // setTreatmentSeachType(value)
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);

    }


    //================================================================================================


    const onFilterTreatmentTypeCreatorChange = async (e: any) => {
        const creatorName = e.target.value;
        console.log('onFilterTreatmentTypeCreatorChange setTreatmenSearchTypeCreatedBy', creatorName)
        setTreatmenSearchTypeCreatedBy(creatorName)
        const newFilter: any = treatmentsFilter;
        newFilter.createdById = undefined;
        const selected = typeCreatorsList.find((a: any) => a.label == creatorName);
        let newList = []
        let sortedList = []
        if (selected && selected.value != '-1') {
            switch (selected.value) {

                case '0':
                    newFilter.createdBy = parseInt(selected.value);
                    newList = creatorsOptionsOld.filter((c: any) => c.status == '0')
                    sortedList = newList.sort((a: any, b: any) => a.label.localeCompare(b.label))
                    setCreatorsList(sortedList)
                    break;
                case '1':
                    newFilter.createdBy = parseInt(selected.value);
                    newList = creatorsOptionsOld.filter((c: any) => c.status == '1')
                    sortedList = newList.sort((a: any, b: any) => a.label.localeCompare(b.label))
                    setCreatorsList(sortedList)
                    break;
                case '2':
                    newFilter.createdBy = parseInt(selected.value);
                    sortedList = creatorsOptionsOld.sort((a: any, b: any) => a.label.localeCompare(b.label))
                    setCreatorsList(sortedList)
                    break;
            }
            setTreatmentsFilter(newFilter);
            getTreatments(newFilter);

        } else {
            newFilter.createdBy = undefined
            setTreatmentsFilter(newFilter);
        }
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter.createdBy = selected ? parseInt(selected.value) : undefined;
            tasksFilter.createdById = undefined;
            if (selected && selected.value != '-1') {
                tasksFilter.creatorsList = [...sortedList];
            }
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }

    }


    const onFilterTreatmentCreatorChange = async (e: any) => {
        const creatorName = e.target.value;
        setTreatmenSearchCreatedBy(creatorName)
        const newFilter: any = treatmentsFilter;
        newFilter.createdById = undefined;
        console.log('creatorName', creatorName)
        const selected = creatorsList.find((a: any) => a.label == creatorName);
        console.log('onFilterTreatmentCreatorChange selected', selected)
        if (selected) {
            //newFilter.createdBy = '3';
            newFilter.createdById = selected.value;
            setTreatmentsFilter(newFilter);
            getTreatments(newFilter);
        } else {
            newFilter.createdById = undefined
            setTreatmentsFilter(newFilter);
        }

        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            if (selected && selected.value) {
                tasksFilter.createdById = selected.value;
            } else {
                tasksFilter.createdById = undefined;
            }
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }

    }


    const onClearFilterFromStorage = (field: string) => {
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter[field] = undefined;
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }
    }




    // ================================================================================================
    const onFilterTreatmentTypeCreatorClear = () => {
        setTreatmenSearchTypeCreatedBy('');
        setCreatorsList([]);

        const newFilter = treatmentsFilter;
        newFilter.createdById = undefined;
        newFilter.createdBy = undefined;
        onClearFilterFromStorage('createdBy');
        onClearFilterFromStorage('createdById');
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }


    const onFilterTreatmentCreatorClear = () => {
        setTreatmenSearchCreatedBy('');
        const newFilter = treatmentsFilter;
        newFilter.createdById = undefined;
        onClearFilterFromStorage('createdById');
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }

    // ================================================================================================

    const onTreatmentTypeHandlerChange = (e: any) => {
        // (value: string, option: { label: string; value: string; }) => {
        const handlerName = e.target.value;
        setTreatmenSearchTypeHandledBy(handlerName)
        const newFilter = treatmentsFilter;
        newFilter.treatmentBy = undefined
        newFilter.treatmentById = undefined;
        const selected = typeHandlersOptions.find((a: any) => a.label == handlerName);
        let newList = []
        if (selected) {
            switch (selected.value) {
                // case '-1':
                //     newFilter.treatmentById = undefined;
                //     break;
                case '0':
                    newFilter.treatmentBy = parseInt(selected.value);
                    newList = creatorsOptionsOld.filter((c: any) => c.status == '0')
                    setHandlersOptions(newList.sort((a: any, b: any) => a.label.localeCompare(b.label)))
                    break;
                case '1':
                    newFilter.treatmentBy = parseInt(selected.value);
                    newList = creatorsOptionsOld.filter((c: any) => c.status == '1')
                    setHandlersOptions(newList.sort((a: any, b: any) => a.label.localeCompare(b.label)))
                    break;
                case '2':
                    newFilter.treatmentBy = parseInt(selected.value);
                    setHandlersOptions([...creatorsOptionsOld.sort((a: any, b: any) => a.label.localeCompare(b.label))])
                    break;
            }
            setTreatmenSearchTypeHandledBy(selected.label)
            setTreatmentsFilter(newFilter);
            getTreatments(newFilter);
        } else {
            newFilter.treatmentBy = undefined
            newFilter.treatmentById = undefined
            setTreatmentsFilter(newFilter);
            if (handlerName == '') {
                getTreatments(newFilter);
            }
        }
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter.treatmentBy = selected ? parseInt(selected.value) : undefined;
            tasksFilter.treatmentById = undefined;
            if (selected && selected.value != '-1') {
                tasksFilter.handlersOptions = [...newList];
            }
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }
    }


    const onTreatmentHandlerChange = (e: any) => {
        // (value: string, option: { label: string; value: string; }) => {
        const handlerName = e.target.value;
        setTreatmenSearchHandledBy(handlerName)
        const newFilter = treatmentsFilter;
        // newFilter.treatmentBy = undefined
        newFilter.treatmentById = undefined;
        const selected = handlersOptions.find((a: any) => a.label == handlerName);
        if (selected) {

            // newFilter.treatmentBy = '3';
            newFilter.treatmentById = selected.value;

            setTreatmenSearchHandledBy(selected.label)
            setTreatmentsFilter(newFilter);
            getTreatments(newFilter);
        } else {
            // newFilter.treatmentBy = undefined
            newFilter.treatmentById = undefined
            setTreatmentsFilter(newFilter);
            if (handlerName == '') {
                getTreatments(newFilter);
            }
        }
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter.treatmentById = selected ? selected.value : undefined;
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }

    }


    // ================================================================================================

    const onClearTreatmentTypeHandler = () => {
        setTreatmenSearchTypeHandledBy('');
        const newFilter = treatmentsFilter;
        newFilter.treatmentBy = undefined
        newFilter.treatmentById = undefined;
        onClearFilterFromStorage('treatmentBy');
        onClearFilterFromStorage('treatmentById');
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }

    const onClearTreatmentHandler = () => {
        setTreatmenSearchHandledBy('');
        const newFilter = treatmentsFilter;
        newFilter.treatmentById = undefined;
        onClearFilterFromStorage('treatmentById');
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }


    const onAssigmentDelete = async (id: string) => {
        const d = await customerCardModel.deleteAssigment(id);
    }

    const onChageDateParam = (value: string, option: { label: string; value: string; }) => {
        const newFilter = treatmentsFilter;
        newFilter.eventDateFrom = undefined;
        newFilter.eventDateTo = undefined;
        newFilter.alertDateFrom = undefined;
        newFilter.alertDateTo = undefined;
        newFilter.createdDateFrom = undefined;
        newFilter.createdDateTo = undefined;
        newFilter.endDateFrom = undefined;
        newFilter.endDateTo = undefined;
        setTreatmentsStartDate(null);
        setTreatmentsEndDate(null);
        setSelectedDateParam(value);
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);

        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter.eventDateFrom = undefined;
            tasksFilter.eventDateTo = undefined;
            tasksFilter.alertDateFrom = undefined;
            tasksFilter.alertDateTo = undefined;
            tasksFilter.createdDateFrom = undefined;
            tasksFilter.createdDateTo = undefined;
            tasksFilter.endDateFrom = undefined;
            tasksFilter.endDateTo = undefined;
            tasksFilter.selectedDateParam = value;
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }
    }

    const onTreatmentStartFilterDateChange = (d: Date) => {
        setTreatmentsStartDate(d);
        const newFilter = treatmentsFilter;
        switch (selectedDateParam) {
            case 'alertDate':
                newFilter.alertDateFrom = d
                break;
            case 'createdDate':
                newFilter.createdDateFrom = d;
                break;
            case 'endDate':
                newFilter.endDateFrom = d;
                break;

            default:
                break;
        }
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            if (selectedDateParam == 'alertDate') {
                tasksFilter.alertDateFrom = d;
            } else if (selectedDateParam == 'createdDate') {
                tasksFilter.createdDateFrom = d;
            } else if (selectedDateParam == 'endDate') {
                tasksFilter.endDateFrom = d;
            }
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }

    const onTreatmentEndFilterDateChange = (d: Date) => {
        setTreatmentsEndDate(d);
        const newFilter = treatmentsFilter;
        switch (selectedDateParam) {
            case 'alertDate':
                newFilter.alertDateTo = d
                break;
            case 'createdDate':
                newFilter.createdDateTo = d;
                break;
            case 'endDate':
                newFilter.endDateTo = d;
                break;
            default:
                break;
        }
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            if (selectedDateParam == 'alertDate') {
                tasksFilter.alertDateTo = d;
            } else if (selectedDateParam == 'createdDate') {
                tasksFilter.createdDateTo = d;
            } else if (selectedDateParam == 'endDate') {
                tasksFilter.endDateTo = d;
            }
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }

    const onInsuranceCompanyChange = (e: any) => {
        const companyName = e.target.value;
        setSelectedInsuranceCompany(companyName);
        const selected = insuranceCompanyList.find((a: any) => a.label == companyName);
        const newFilter = treatmentsFilter;
        if (selected) {
            newFilter.insuranceCompanyId = selected.value
            setSelectedInsuranceCompany(selected.label)
            setTreatmentsFilter(newFilter);
            getTreatments(newFilter);
        } else {
            newFilter.insuranceCompanyId = undefined
            setTreatmentsFilter(newFilter);
            if (companyName == '') {
                getTreatments(newFilter);
            }
        }
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter.insuranceCompanyId = selected ? selected.value : undefined;
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }
        // const newFilter = treatmentsFilter;
        // if (value !== '0') {
        //     newFilter.insuranceCompanyId = value
        // } else {
        //     newFilter.insuranceCompanyId = undefined;
        // }
        // setTreatmentsFilter(newFilter);
        // getTreatments(newFilter);
    }
    const onClearInsuranceCompany = () => {
        setSelectedInsuranceCompany('');
        const newFilter = treatmentsFilter;
        newFilter.insuranceCompanyId = undefined
        onClearFilterFromStorage('insuranceCompanyId');
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }


    const onAgentChange = (value: string, option: { label: string; value: string; }) => {
        setSelectedAgent(value);
        const newFilter = treatmentsFilter;
        if (value !== '0') {
            newFilter.agentId = value
        } else {
            newFilter.agentId = undefined;
        }
        const tasksLocalStorage = localStorage.getItem('lastTasksFilter');
        if (tasksLocalStorage) {
            const tasksFilter = JSON.parse(tasksLocalStorage);
            tasksFilter.agentId = value !== '0' ? value : undefined;
            localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter));
        }
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }


    const clearTreatmentsFliter = () => {
        const newFilter: any = {
            page: 1,
            searchTerm: undefined,
            userId: undefined,
            createdById: undefined
        };
        setSelectedDateParam('0')
        setTreatmentSeachType('-1');
        setTreatmentsSearchText('');

        setTreatmenSearchTypeHandledBy('');
        setTreatmenSearchHandledBy('');

        setTreatmenSearchTypeCreatedBy('');
        setTreatmenSearchCreatedBy('');

        setCreatorsList([]);
        setHandlersOptions([]);

        setTreatmentsStartDate(null);
        setTreatmentsEndDate(null);
        setTreatmentSeachStatus('-1');
        setSelectedInsuranceCompany('');
        setSelectedAgent('0');
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);

        const tasksFilter = {
            page: 1
        };
        localStorage.setItem('lastTasksFilter', JSON.stringify(tasksFilter))
    }

    // treatments function end

    const showHideAddTreatmentPopup = (show: boolean) => {
        dispatch(setLeadIdForTreatment(""))
        setShowAddTreatmentPopup(show);
    }

    const hideTreatmentConfigPopup = () => {
        setShowTreatmentConfigPopup(false)
    }

    const showHideSendEmailPopup = (show: boolean) => {
        setShowSendEmailPopup(show);
    }
    const showHideSendWhatsAppPopup = (show: boolean) => {
        setShowSendWhatsAppPopup(show);
    }
    const hideDeleteAssingmentPopup = () => {
        setShowDeleteAssignmentPopup(false)
    }
    const showDeleteAssingmentPopup = () => {
        setShowDeleteAssignmentPopup(true)
    }


    const closeMessagePopup = () => {
        setPopupMessageContent(null);
        setPopupMessageTitle(undefined)
    }


    const sendEmail = (id: string) => {
        showHideSendEmailPopup(true)
    }

    const sendWhatsApp = (id: string) => {
        showHideSendWhatsAppPopup(true)
    }

    const setStatus = (id: string, status: string) => {
        customerCardModel.setAssignmentStatus(id, status).then((res: any) => {
            getTreatments();
        })
    }

    const deleteAssigment = (id: string) => {
        // console.log('deleteAssigment');
        // if(props.actions && props.actions.delete) {
        //     props.actions.delete(id);
        // }
        if (id && id != '') {
            setAssignmentIdForDelete(id);
            setShowDeleteAssignmentPopup(true);
            // 
        }
    }

    const onApproveDeleteAssignment = (id: string) => {
        setLoading(true)
        customerCardModel.deleteAssigment(id);
        setAssignmentIdForDelete(null);
        setShowDeleteAssignmentPopup(false);
        console.log('onApproveDeleteAssignment', id)
        setLoading(false);
        getTreatments();

        setPopupMessageContent('המשימה נמחקה בהצלחה');
        setPopupMessageTitle('מחיקת משימה');
    }

    const onSortChange = async (property: string) => {
        let currentSort: any = sortBy ? { ...sortBy } : {
            property: "createdDate",
            SortDirection: ""
        };

        const filter = treatmentsFilter;
        if (currentSort.property == property && sortBy && sortBy.SortDirection == 'DESC') {
            await setSortBy(undefined);
            filter.sortBy = undefined;
        } else {
            if (currentSort.property == property && sortBy) {
                currentSort.SortDirection = sortBy.SortDirection == 'ASC' ? 'DESC' : 'ASC'
            } else {
                currentSort.SortDirection = 'ASC';
                currentSort.property = property;
            }
            await setSortBy(currentSort);
            filter.sortBy = [currentSort];
        }
        getTreatments(filter);
    }

    const editTask = async (id?: string) => {



        if (!id) {
            setSelectedAssigment({
                "id": null,
                "createdDate": null,
                "eventDate": null,
                "alertDate": null,
                "treatmentType": 0,
                "topic": "",
                "note": "2",
                "filePath": null,
                "customerId": null,
                "customer": null,
                "from": "",
                "to": "",
                "cc": "",
                "bcc": "",
                "assignmentStatus": null,
                "policyRelatedId": null,
                "policyRelated": null,
                "sueRelatedId": null,
                "sueRelated": null,
                "leadRelatedId": null,
                "leadRelated": null,
                "relationEntitiesModel": null,
                "agentId": null,
                "agent": null,
                "userId": null,
                "user": null,
                "startDate": null,
                "endDate": new Date(),
                "fileAttachment": null,
                "customersIds": null,
                "leadsIds": null,
                "companyId": null,
                "company": null,
                "priority": null,
                "treatmentOutcome": null,
                "emailDeliveryType": null,
                "address": null,
                "smsFrom": null,
                "smsTo": null,
                "smsMessage": null,
                "smsPhone": null,
                "smsSenderId": null,
                "faxPhone": null,
                "sentByFax": null,
                "faxBy": null,
                "faxInHonorOf": null,
                "statusChangeEmail": null,
                "statusChangeSms": null,
                "location": null,
                "includeLogo": false,
                "emailBody": "",
                // "emailBody": "KYUSHU PLUS 4X2 (1987) היברידי רגיל פנאי-שטח;;;<p><span style=\"font-size:16px\"><strong><u>ביטוח מסוג מקיף כולל כיסוי תאונה וגניבה </u></strong></span></p>\r\n\r\n<p><span style=\"font-size:16px\"><u>הביטוח כולל:</u></span></p>\r\n\r\n<ul dir=\"rtl\">\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData3</span></span></li>\r\n\t<li><span style=\"font-size:16px\">התחייבות לתיקון בחלפים מקוריים במוסך מורשה לקסוס.</span></li>\r\n\t<li><span style=\"font-size:16px\">גרירה ושרותי דרך 24 שעות ביממה- ממסי בטלפון 5202*. (כולל החלפת גלגל, גרירה מכביש 6 ומחניונים)</span></li>\r\n\t<li><span style=\"font-size:16px\">החזר הוצאות נסיעה ממקום התאונה עד 250 שח , במידה והרכב אינו במצב נסיעה.</span></li>\r\n\t<li><span style=\"font-size:16px\">כיסוי שבר שמשות סטנדרטי (לא מקורי) ללא השתתפות עצמית</span></li>\r\n\t<li><span style=\"font-size:16px\">רכב חליפי לקסוס* : לנהגים מגיל 24 מעל שנה ותק נהיגה :&nbsp;בתאונה - רכב חליפי במוסך הסדר לקסוס &nbsp;מפתח תמורת מפתח.&nbsp;בגניבה או טוטאלוסט -30 יום או עד קבלת תשלום מחברת הביטוח (המוקדם מביניהם)</span></li>\r\n\t<li><span style=\"font-size:16px\">גבול אחריות לפגיעה בצד ג&#39; 1,500,000 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">כינון אוטומט במוסך הסדר - ללא תוספת פרמיה.</span></li>\r\n\t<li><span style=\"font-size:16px\">הרכב יחשב לאובדן כללי בנזק מעל 50% בלבד.</span></li>\r\n\t<li><span style=\"font-size:16px\">השתתפות עצמית במוסכי הסדר לקסוס :&nbsp;לרכב בשווי עד 350000 שח &nbsp;1390 ₪ , לנהגים עד גיל 21 &nbsp;)לא חדשים) 2092 ש&quot;ח, לנהגים מגיל 17 או לנהגים חדשים 2794 ₪ &#39;&nbsp;&nbsp;לרכב בשווי מעל 350000 שח : 2000 ₪ , &nbsp; &nbsp; לנהגים 17+ או נהגים חדשים 3000 ₪ .</span></li>\r\n\t<li dir=\"RTL\" style=\"text-align:right\"><span style=\"font-size:16px\"><span style=\"font-family:&quot;Times New Roman&quot;,&quot;serif&quot;\"><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">השתתפות עצמית בירידת ערך 1.5%</span><span dir=\"LTR\" style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">.</span><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\"> ברכבים בשווי מעל 350000 שח- השתתפות עצמית בירידת ערך 5%.</span></span></span></li>\r\n\t<li><span style=\"font-size:16px\">הגנה משפטית עד 50,000 ₪. ה&quot;ע 200 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">ביטוח תוספות ואבזור ברכב עד 10,000 ₪ ללא תוספת פרמיה בכפוף להצגת חשבונית בגין האביזרים טרם עריכת הביטוח .</span></li>\r\n\t<li><span style=\"font-size:16px\">שירות VIP ללקוחות הקולקטיב 24 שעות ביממה בטלפון 8099*.</span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData1</span></span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData2</span></span></li>\r\n</ul>\r\n\r\n<p dir=\"RTL\"><span style=\"font-size:16px\">*רכב חליפי לקסוס או לחילופין רכב מנהלים&nbsp;על בסיס&nbsp;&nbsp;זמינות המשכיר.</span></p>\r\n\r\n<p>&nbsp;</p>\r\n;;;<p dir=\"RTL\"><span style=\"font-size:14px\"><strong><u>הביטוח מותנה וכפוף</u></strong><strong><u>:</u></strong></span></p>\r\n\r\n<ul>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">באישור העדר תביעות ביטוח מקיף 3 שנים אחרונות &ndash; יש להציג אישור תוך 7 ימים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">אישור בדיקת מיגון הנדרש ע&quot;י חברת הביטוח.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">כל הכיסויים בכפוף לתנאי הפוליסה ולכתבי השירות הרלוונטיים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">את הביטוח מקיף ניתן לחלק ב-4 תש&#39; ללא ריבית וחובה ב-12 תש&#39; ללא ריבית.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">חלק מהכיסויים נמכרים ללא מעורבות חב&#39; הביטוח והנם באחריות מלאה של נותני השירות .</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">ט.ל.ח</span></li>\r\n</ul>\r\n",
                "includeCustomerInfo": false,
                "isFullDay": false,
                "forTreatmentById": null,
                "forTreatmentBy": null,
                "belongsToId": null,
                "belongsTo": null,
                "employer": null,
                "employerId": null,
                "riderId": null,
                "rider": null,
                "status": null,
                "assignmentStatusType": 0,
                "whatsAppMessageId": null,
                "treatmentActivities": [],
                "treatmentTypeIcon": "fa-mobile-alt",
                "upsertActionName": "UpsertSmsTreatment",
                "FileAttachments": [],
            })
            // setSelectedAssigment(new TreatmentModel());
        } else {

            // need to check which type of treatment we edit
            // if is type 3 of mail we need to set on redux pruperty of popUpTreatmentModel: show to true and type to 3
            // 
            const data = await customerCardModel.getAssignment(id);
            if (data && data.treatmentType == 1) {
                await customerCardModel.setAssignmentSeen(id);
                if (treatmentsList) {
                    let treatmentsListToUpdate = [...(treatmentsList || [])];
                    const idx = treatmentsListToUpdate.findIndex((t: any) => t.id === id);
                    if (idx >= 0) {
                        const current = treatmentsListToUpdate[idx];
                        treatmentsListToUpdate[idx] = { ...current, seen: true }; // ✅ new object
                        setTreatmentsList(treatmentsListToUpdate);
                    }
                }
                if (data.endDate == '0001-01-01T00:00:00') {
                    data.endDate = moment().format('YYYY-MM-DDTHH:ss');
                }
                setSelectedAssigment(data);
            }
        }
        setShowAddTreatmentPopup(true)
    }

    const editEmail = async (id: string) => {
        console.log('editEmail', id)
        await customerCardModel.setAssignmentSeen(id);
        if (treatmentsList) {

            const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
            console.log('editEmail treatmentsList', treatmentsList)
            treatmentsList[taskIndex].seen = true;
            setTreatmentsList(treatmentsList);
            setShowAddTreatmentPopup(true);
        }
        console.log('editEmail showAddTreatmentPopUp', showAddTreatmentPopUp)
        dispatch(setPopUpTreatmentModel({ show: true, type: 3 }));

    }

    const editDoc = async (id: string) => {
        await customerCardModel.setAssignmentSeen(id);
        if (treatmentsList) {
            setTreatmentId(id);

            const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
            if (taskIndex >= 0 && treatmentsList[taskIndex]) {
                treatmentsList[taskIndex].seen = true;
                setTreatmentsList(treatmentsList);
            }
            setShowAddTreatmentPopup(true);
        }
        dispatch(setPopUpTreatmentModel({ show: true, type: 4 }));
    }

    const onSaveTask = async (data: any) => {
        if (data.endDate) {
            if (typeof (data.endDate) !== 'object') {
                data.endDate = new Date(data.endDate);
            }
        }
        const d = await customerCardModel.upsertAssignment(data);
        showHideAddTreatmentPopup(false);
        getTreatments();
        if (data.id === null || data.id === '00000000-0000-0000-0000-000000000000') {
            setPopupMessageContent('המשימה נוצרה בהצלחה');
            setPopupMessageTitle('יצירת משימה');
        } else {
            setPopupMessageContent('המשימה עודכנה בהצלחה');
            setPopupMessageTitle('עדכון משימה');
        }
        dispatch(setLeadIdForTreatment(""))

        return d;
    }


    const onShowDocumentPopUp = (url: any[]) => {
        setDocumentUrl(url);
    }

    const redirectToClient = (customer: any) => {
        const savedTabsStr = localStorage.getItem('clientsOpenTabs');
        let savedTabs: any[] = [];
        if (savedTabsStr) {
            savedTabs = JSON.parse(savedTabsStr);
        }
        const existingTab = savedTabs.find(t => t.id === customer.id);
        if (existingTab) {
            // Tab already exists, no need to add again
            navigate(`/Clients/`);
            return;
        }
        // Add new tab
        const tContent: any = {
            type: "editCustomer",
            title: customer.fullName,
            id: customer.id,
            mode: 1,
            editData: undefined,
            loaded: false
        }
        savedTabs.push(tContent);
        localStorage.setItem('clientsOpenTabs', JSON.stringify(savedTabs));

        navigate(`/Clients/`);
    }



    const onHideDocumentPopUp = () => {
        setDocumentUrl([]);
    }

    const setEditTaskIdAndShowAddTreatmentPopup = async (show: boolean, taskId: string, treatmentType: number) => {
        setShowAddTreatmentPopup(show);
        if (taskId && taskId != '') {
            if (treatmentType == 1) {
                setSelectedAssigment(null);
                await editTask(taskId);
            } else if (treatmentType == 4) {
                // redirect from notification to task type Doc
                setSelectedAssigment(null);
                dispatch(setTypeTreatmentsAction("edit"));
                dispatch(setTreatmentId(taskId));
                await editDoc(taskId);
            }

        } else {
            setSelectedAssigment(null);
        }
    }

    const emptyFunc = (t?: any, v?: any) => { }

    useEffect(() => {
        console.log('location.state', location)

        if (location.state && location.state.openEditPopup && location.state.taskId) {
            // Set the task to edit and open popup

            setEditTaskIdAndShowAddTreatmentPopup(location.state.openEditPopup, location.state.taskId, location.state.treatmentType);

            // console.log('location.state.taskId', location.state.taskId)
            // editTask(location.state.taskId);
            // setShowAddTreatmentPopup(true);
            // Clear the state
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    useEffect(() => {
        if (didInitRef.current) return;       // already ran → skip
        didInitRef.current = true;            // mark as executed
        init()
    }, [])

    // useEffect(() => {
    //     if (agents && agents.length > 0) {
    //         if (currentUser) {
    //             const newFilter = treatmentsFilter;
    //             const selected = creatorsList.find((a: any) => a.value == currentUser.id);
    //             if (selected) {
    //                 // newFilter.treatmentBy = '3';
    //                 // newFilter.treatmentById = selected.value;
    //                 newFilter.treatmentBy = '0';
    //                 newFilter.createdBy = '0';
    //                 // setTreatmenSearchTypeCreatedBy('יוזרים פעילים');
    //                 // setTreatmenSearchTypeHandledBy('יוזרים פעילים')
    //                 // setTreatmenSearchHandledBy(selected.label);
    //                 // setTreatmenSearchTypeHandledBy(selected.label);
    //             }
    //         }
    //         getTreatments();
    //     }
    // }, [agents])

    // useEffect(() => {
    //     const newFilter = treatmentsFilter;
    //     newFilter.assignmentStatus = '45cb3c16-f64f-40d5-9863-42a742ce4624';
    //     setTreatmentSeachStatus(newFilter.assignmentStatus);
    // }, [assigmentStatuses])

    useEffect(() => {
        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
            // console.log('loggedUser', loggedUser)
            setCurrentUser(loggedUser);
        }
    }, [userLogged])


    const updateSeen = async (id: string) => {
        await customerCardModel.setAssignmentSeen(id);
        if (treatmentsList) {
            const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
            treatmentsList[taskIndex].seen = true;
            setTreatmentsList(treatmentsList);
        }
    }

    const isAdmin = () => {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            return loggedUser.role == 0
        }
        return false;
    }

    const updateTask = async (messageType: string, assignment: any) => {
        console.log('updateTask', messageType, assignment)
        if (messageType == 'NewAssignmentMessage') {

            const newAssigment = {
                ...Object.fromEntries(
                    Object.entries(assignment).map(([key, value]) => [key.charAt(0).toLowerCase() + key.slice(1), value])
                )
            }
            // add assignment to list of assignments
            if (newAssigment && newAssigment.id) {
                console.log('newAssigment', newAssigment)
                const loggedUser: any = localStorage.getItem('loggedUser');
                if (loggedUser) {
                    const loggedUserInfo = JSON.parse(loggedUser);
                    console.log('loggedUserInfo', loggedUserInfo)
                    if (newAssigment.belongsToId == loggedUserInfo.id) {
                        console.log('updateTask', loggedUserInfo.id, newAssigment.belongsToId)

                        // const newAssignmentsList= _.cloneDeep(treatmentsList)
                        // copy the treatmentsList to new variable as copy
                        let newAssignmentsList = treatmentsList ? [...treatmentsList] : [];
                        console.log('newAssignmentsList', newAssignmentsList)
                        if (newAssignmentsList && newAssignmentsList.length > 0) {

                            newAssignmentsList.push(newAssigment);
                            await setTreatmentsList([...newAssignmentsList])
                            console.log('treatmentsList ', treatmentsList)
                        }
                    }

                }
            }
        }
    }

    return (

        <div className="main-content clients-main-content rtl">
            {
                loading && (
                    <PleaseWaitLayer />
                )
            }
            {
                !userLogged && <LoginPopup />
            }
            {
                documentUrl && documentUrl.length > 0 && (
                    <TaskDocumentPopup
                        ClosePopup={onHideDocumentPopUp}
                        documentUrl={documentUrl}
                    />
                )
            }
            {
                showAddTreatmentPopUp && selectedAssigment && usersList.length > 0 &&
                <TasksAddTaskPopup
                    ShowHidePopup={showHideAddTreatmentPopup}
                    type={1}
                    dataToEdit={selectedAssigment}
                    statuses={assigmentStatuses}
                    onSave={onSaveTask}
                    ClosePopup={() => showHideAddTreatmentPopup(false)}
                    // customersList={customersList}
                    usersList={usersList}
                />
            }

            {showAddTreatmentPopUp && (popUpTreatmentModel.type == 3 || popUpTreatmentModel.type == 4) && popUpTreatmentModel.show &&
                <ClientAddTreatmentPopup
                    ShowHidePopup={showHideAddTreatmentPopup}
                    type={popUpTreatmentModel.type}
                    ClosePopup={() => showHideAddTreatmentPopup(false)}
                // customerId={treatmentId}
                // customerId={sellectedCustomerId ? sellectedCustomerId : ''}
                // showPopUpMessage={showPopUpMessage}
                />
            }



            {
                showSendEmailPopUp &&
                <TasksSendEmailPopup
                    ShowHidePopup={showHideSendEmailPopup}
                    type={1}
                    ClosePopup={() => showHideSendEmailPopup(false)}
                />
            }
            {
                showSendWhatsAppPopUp &&
                <TasksSendWhatsAppPopup
                    // messageTitle={newTreatmentType.toString()}
                    ShowHidePopup={showHideSendWhatsAppPopup}
                    type={1}
                    ClosePopup={() => showHideSendWhatsAppPopup(false)}
                />
            }
            {
                showTreatmentConfigPopUp &&
                <ClientTreatmentConfigPopup
                    ClosePopup={hideTreatmentConfigPopup}
                    config={{}}
                    messageTitle={'הגדרות'}
                />
            }
            {
                showDeleteAssignmentPopUp && <ConfirmPopUp
                    data={assignmentIdForDelete}
                    messageTitle={'מחיקת משימה'}
                    message={'האם את/ה בטוח?'}
                    OnApprove={onApproveDeleteAssignment}
                    ClosePopup={hideDeleteAssingmentPopup} />
            }


            {
                popupMessageContent != null && popupMessageContent != '' ?
                    (
                        <LeadMessagePopup
                            ClosePopup={() => closeMessagePopup()}
                            approveBtnTitle={''}
                            messageContent={popupMessageContent}
                            messageTitle={popupMessageTitle}
                        />
                    ) : ""
            }

            <SignalTaskServiceModel onNewAssignmentMessage={updateTask} />


            <Menu activePage='Tasks' />
            <div className="center-content">
                <Header PageName="משימות" />
                <section className="page-tab-row">

                </section>
                <section className={`page-tab-content all-clients selected`} id="all-clients">
                    <div className="content-header">
                        <div className="flex-end desktop-only clients-search-row client-list-search client-list-view">
                            <div className="list-actions-row flex-centered flex-space-between">
                                <div className="filter-row flex-centered client-search">
                                    <div>
                                        <div className="filter-input select autocomplete treatment-type-select">
                                            <input type='text'
                                                list="cretors_list_type"
                                                placeholder='נוצר ע"י סוג'
                                                onChange={(e: any) => onFilterTreatmentTypeCreatorChange(e)}
                                                value={treatmentSearchTypeCreatedBy}
                                            />
                                            <datalist id="cretors_list_type">
                                                {typeCreatorsList && typeCreatorsList.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                                            </datalist>
                                            <div className={`icon x-clear pointer ${treatmentSearchTypeCreatedBy == '' ? 'hide' : ''}`} onClick={onFilterTreatmentTypeCreatorClear}></div>
                                        </div>

                                        <div className="filter-input select autocomplete treatment-type-select">
                                            <input type='text'
                                                list="cretors_list"
                                                placeholder='נוצר ע"י'
                                                onChange={(e: any) => onFilterTreatmentCreatorChange(e)}
                                                value={treatmentSearchCreatedBy}
                                            />
                                            <datalist id="cretors_list">
                                                {creatorsList && creatorsList.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                                            </datalist>
                                            <div className={`icon x-clear pointer ${treatmentSearchCreatedBy == '' ? 'hide' : ''}`} onClick={onFilterTreatmentCreatorClear}></div>
                                        </div>
                                    </div>



                                    <div>
                                        <div className="filter-input select autocomplete treatment-type-select">
                                            <input type='text'
                                                list="handlers_list_type"
                                                placeholder='לטיפול ע"י סוג'
                                                onChange={(e: any) => onTreatmentTypeHandlerChange(e)}
                                                value={treatmentSearchTypeHandledBy}
                                            />
                                            <datalist id="handlers_list_type">
                                                {typeHandlersOptions && typeHandlersOptions.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                                            </datalist>
                                            <div className={`icon x-clear pointer ${treatmentSearchTypeHandledBy == '' ? 'hide' : ''}`} onClick={onClearTreatmentTypeHandler}></div>
                                        </div>

                                        <div className="filter-input select autocomplete treatment-type-select">
                                            <input type='text'
                                                list="handlers_list"
                                                placeholder='לטיפול ע"י'
                                                onChange={(e: any) => onTreatmentHandlerChange(e)}
                                                value={treatmentSearchHandledBy}
                                            />
                                            <datalist id="handlers_list">
                                                {handlersOptions && handlersOptions.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                                            </datalist>
                                            <div className={`icon x-clear pointer ${treatmentSearchHandledBy == '' ? 'hide' : ''}`} onClick={onClearTreatmentHandler}></div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="filter-input select treatment-type-select">

                                            {/* <IDNameDescriptionItemSelect
                                                OnChange={(name: string, value: any) => setFilterTreatmentType(name, value)}
                                                Id={"treatmentType"}
                                                Value={treatmentSeachType}
                                                Options={treatmentsTypeList}
                                            /> */}

                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="סוג פעולה"
                                                value={treatmentSeachType}
                                                onChange={setFilterTreatmentType}
                                                options={treatmentsTypeList}
                                            />
                                        </div>
                                        <div className="filter-input select treatment-type-select">
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="סטטוס"
                                                value={treatmentSeachStatus}
                                                onChange={setFilterTreatmentStatus}
                                                options={[
                                                    {
                                                        label: 'כל הסטטוסים',
                                                        value: '-1'
                                                    },
                                                    ...assigmentStatuses,
                                                    // {
                                                    //     label: 'בפיגור',
                                                    //     value: '-2'
                                                    // },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="filter-input autocomplete treatment-type-select">
                                            <input type='text'
                                                list="companies_list"
                                                placeholder='חברת ביטוח'
                                                onChange={(e: any) => onInsuranceCompanyChange(e)}
                                                value={selectedInsuranceCompany}
                                            />
                                            <datalist id="companies_list">
                                                {insuranceCompanyList && insuranceCompanyList.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                                            </datalist>
                                            <div className={`icon x-clear pointer ${selectedInsuranceCompany == '' ? 'hide' : ''}`} onClick={onClearInsuranceCompany}></div>
                                            {/* <Select
                                                style={{ width: '100%' }}
                                                value={selectedInsuranceCompany}
                                                onChange={(value: string, option: any)=>onInsuranceCompanyChange(value, option)}
                                                options={
                                                    [
                                                        {
                                                        label: 'חברת ביטוח',
                                                        value: '0'
                                                        },
                                                        ...insuranceCompanyList
                                                    ]
                                                }
                                            /> */}
                                        </div>
                                        <div className="filter-input select">
                                            <Select
                                                style={{ width: '100%' }}
                                                value={selectedAgent}
                                                onChange={(value: string, option: any) => onAgentChange(value, option)}
                                                options={
                                                    [
                                                        {
                                                            label: 'סוכן ביטוח',
                                                            value: '0'
                                                        },
                                                        ...agentsList
                                                    ]
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="filter-input select treatment-type-select">
                                            <Select
                                                style={{ width: '100%' }}
                                                value={selectedDateParam}
                                                onChange={(value: string, option: any) => onChageDateParam(value, option)}
                                                options={
                                                    [
                                                        {
                                                            label: 'ללא סינון לפי תאריך',
                                                            value: '0'
                                                        },
                                                        {
                                                            label: 'סינון לפי תאריך יצירה',
                                                            value: 'createdDate'
                                                        },
                                                        {
                                                            label: 'סינון לפי תאריך תזכורת',
                                                            value: 'alertDate'
                                                        },
                                                        {
                                                            label: 'סינון לפי תאריך סיום',
                                                            value: 'endDate'
                                                        }
                                                    ]
                                                }
                                            />
                                        </div>
                                        <div className="search-input flex-end treatment-date-field">
                                            <div className="label">
                                                מ:
                                            </div>
                                            <div className="filter-input select">
                                                <CompDatePicker disabled={selectedDateParam == '0'} value={treatmentsStartDate} onChange={(date: Date) => onTreatmentStartFilterDateChange(date)} />
                                            </div>
                                        </div>
                                        <div className="search-input flex-end treatment-date-field">
                                            <div className="label">
                                                עד:
                                            </div>
                                            <div className="filter-input select">
                                                <CompDatePicker disabled={selectedDateParam == '0'} value={treatmentsEndDate} onChange={(date: Date) => onTreatmentEndFilterDateChange(date)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="filter-input select search">
                                            <Select
                                                style={{ width: '100%' }}
                                                value={'0'}
                                                onChange={(value: string, option: any) => emptyFunc(value, option)}
                                                options={
                                                    [
                                                        {
                                                            label: 'קבוצה',
                                                            value: '0'
                                                        }
                                                    ]
                                                }
                                            />
                                        </div>
                                        <div className="filter-input search">
                                            <input type="text" value={treatmentsSeachText} placeholder="חיפוש" onChange={handleTreatmentSearchChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { getTreatments(); }
                                                }} />
                                            <div className="icon search"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="filter-button">
                                            <button className="act-btn" onClick={(e: any) => getTreatments()}>הצג דוח</button>
                                        </div>
                                        <div className="filter-button">
                                            <button className="act-btn" onClick={clearTreatmentsFliter}>נקה בחירה</button>
                                        </div>
                                        <div className="filter-button">
                                            <button className="act-btn" onClick={emptyFunc}>הדפס דוח</button>
                                        </div>
                                        <div className="filter-button">
                                            <button className="act-btn" onClick={emptyFunc}>יצוא לאקסל</button>
                                        </div>
                                    </div>
                                </div>
                                {isAdmin() &&
                                    <div className="cliets-main-buttons">
                                        <button type="button" className="button blue has-icon flex-centered flex-justify-center" onClick={() => editTask()}>
                                            <div className="icon add"></div>
                                            הוסף
                                        </button>
                                        {isAdmin() &&
                                            <div className="icon icon-config gear" onClick={() => setShowTreatmentConfigPopup(true)}></div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <TasksTable
                        data={treatmentsList}
                        sortBy={sortBy}
                        className='big'
                        actions={{
                            edit: (id: string) => editTask(id),
                            editEmail: (id: string) => editEmail(id),
                            editDoc: (id: string) => editDoc(id),
                            sendEmail: (id: string) => sendEmail(id),
                            sendWhatsApp: (id: string) => sendWhatsApp(id),
                            print: (id: string) => emptyFunc(),
                            setStatus: (id: string, newStatus: string) => setStatus(id, newStatus),
                            delete: (id: string) => deleteAssigment(id),
                            onSortChange: (property: string) => onSortChange(property),
                            onShowDocument: (url: any[]) => onShowDocumentPopUp(url),
                            redirectToClient: (id: string) => redirectToClient(id),
                            updateSeen: (id: string) => updateSeen(id),

                            getTreatments: (filter: any) => getTreatments(filter),
                        }}
                    />

                    <footer className="footer emails-list-footer emails-list-view">
                        <Pagger pagerConf={pagerConf} changePage={onPageChange} refresh={emptyFunc}></Pagger>
                    </footer>
                </section>



            </div>
        </div>
    )
}
export default Tasks;